import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PlatformDetectionService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * True for iPhone, iPad (classic and iPadOS 13+ "desktop" UA), and macOS -
   * i.e. any Apple device, per product requirement to treat Mac the same as iOS.
   */
  isIOS(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform || '';

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return true;
    }

    // iPadOS 13+ reports a "MacIntel" platform but exposes touch support.
    if (platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return true;
    }

    return /Mac/i.test(platform);
  }
}
